import { Bar, BarConfig } from '@ant-design/plots';
import { useLazyQuery } from '@apollo/client';
import { GET_CHALLENGES_BY_TOPICS, PopularTopic } from '@frontend/data-access';
import { Card, Select } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';

function IntraChallengesByTopicStats({ className }: { className?: string }) {
  const { t } = useTranslation('admin');

  const [filter, setFilter] = useState<string[]>([]); // New state for search term
  const [getData, { data, loading }] = useLazyQuery<{
    challengesByTopics: PopularTopic[];
  }>(GET_CHALLENGES_BY_TOPICS);

  useEffect(() => {
    getData({
      variables: {
        input: {
          type: 'INTERNAL',
          order: true,
        },
      },
    });
  }, [getData]);

  const filteredData =
    data?.challengesByTopics.filter((item) =>
      filter.length > 0 ? filter.includes(item.topic) : true
    ) || [];

  const config: BarConfig = {
    data: filteredData, // Use the filtered data
    loading: loading,
    xField: 'topic',
    yField: 'count',
    color: '#529FF0',
    appendPadding: [0, 20, 0, 0],
    yAxis: {
      label: {
        formatter: (value) =>
          value.length > 30 ? value.slice(0, 30) + '...' : value,
        style: {
          fontFamily: 'Lufga',
          fill: 'rgba(0, 0, 0, 0.65)',
          textAlign: 'right',
        },
        labelFormatter: (value) =>
          value.length > 30 ? value.slice(0, 30) + '...' : value,
      },
    },
    label: {
      text: 'count',
      position: 'right',
      textAlign: 'start',
      dx: 8,
      style: {
        fill: 'rgba(0, 0, 0, 0.65)',
        fontFamily: 'Lufga',
      },
    },
  };

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
      className={`${className}`}
    >
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <div className="text-sm font-medium">
            <div className="text-gray-900">
              {t('intra_challenges_by_topic')}
            </div>
            <span className="text-gray-700">
              {t('by_number_of_created_challenges')}
            </span>
          </div>
          <div>
            <Select
              onChange={setFilter}
              options={data?.challengesByTopics.map((item) => ({
                label: item.topic,
                value: item.topic,
              }))}
              value={filter}
              placeholder={t('search_by_topics')}
              allowClear
              mode="multiple"
              className="!w-56"
              maxTagCount="responsive"
              optionFilterProp="label"
            />
          </div>
        </div>
        <Bar {...config} />
      </div>
    </Card>
  );
}

export default IntraChallengesByTopicStats;
